module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-row action-list-item list-item",
    style: ({
      cursor: _vm.cursor
    }),
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "data-target": _vm.data_target_id
    },
    on: {
      "mouseover": function($event) {
        _vm.row_hovered = true
      },
      "mouseleave": function($event) {
        _vm.row_hovered = false
      }
    }
  }, [_c('div', {
    staticClass: "table-col table-col-500"
  }, [_c('div', {
    staticClass: "action-info",
    class: _vm.action.signature
  }, [_c('div', {
    staticClass: "action-human-step"
  }, [_vm._v(_vm._s(_vm.action_legend))]), _c('div', {
    staticClass: "action-name"
  }, [_vm._v(_vm._s(_vm.action.name))])])]), (_vm.action.isEmailFlowAction() && _vm.action.email_statistic) ? [_c('statistic-table-col', {
    attrs: {
      "total": _vm.action.email_statistic.sent,
      "value": _vm.action.email_statistic.open,
      "label": _vm.$t('flows.attributes.opening'),
      "show_details": _vm.row_hovered
    }
  }), _c('statistic-table-col', {
    attrs: {
      "total": _vm.action.email_statistic.sent,
      "value": _vm.action.email_statistic.reply,
      "label": _vm.$t('flows.attributes.reply'),
      "show_details": _vm.row_hovered
    }
  })] : [_c('div', {
    staticClass: "table-col"
  }), (!_vm.action.isEmailFlowAction() && _vm.qualification_statistics) ? _c('statistic-table-col', {
    attrs: {
      "value": _vm.action.recipients_statistics.total.count,
      "show_raw_value": true,
      "label": _vm.$t('flows.attributes.performed')
    }
  }) : _vm._e()], (_vm.show_conversion_statistic) ? _c('statistic-table-col', {
    attrs: {
      "total": _vm.total_for_conversion,
      "value": _vm.conversion,
      "label": _vm.$t('flows.attributes.conversion'),
      "show_details": _vm.row_hovered
    }
  }) : _vm._e(), _c('div', {
    staticClass: "table-col table-col-collapsed"
  }), (_vm.has_template) ? _c('div', {
    staticClass: "preview",
    staticStyle: {
      "flex": "0 1 100%"
    },
    attrs: {
      "id": _vm.preview_id
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.label_by_template_kind)), _c('span', [_vm._v(_vm._s(_vm.value_by_template_kind))])]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.action.template.body)
    }
  })])]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20805a86!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow_actions/list_item.vue
// module id = 1044
// module chunks = 1